import React from 'react';
import {SchemaContext} from "../schema/context/SchemaContext";
import {ObjectContextProvider} from "./context/ObjectContext";
import ObjectView from "./view/ObjectView";
import AlertWarning from "../../common/alert/AlertWarning";
import Loader from "../loader/Loader";

export type ObjectDetailsProps = {
  id: string
  type?: string
  renderTitle?: boolean
  forceNewTabs?: boolean
}

/**
 * Component for controlling and visualizing an object details information.
 */
export default class ObjectDetails extends React.Component<ObjectDetailsProps> {

  static contextType = SchemaContext;

  render() {
    const {loading, graphQlSchema} = this.context;

    if (loading) {
      return (
        <div className="text-center">
          <Loader size="lg" block={true}/>
          <div>Loading GraphQL schema</div>
        </div>
      );
    }

    if (!graphQlSchema) {
      return <AlertWarning>No GraphQL schema</AlertWarning>
    }

    return (
      <ObjectContextProvider graphQlSchema={graphQlSchema}
                             objectId={this.props.id}
                             objectType={this.props.type}
                             forceNewTabs={this.props.forceNewTabs}>
        <ObjectView renderTitle={this.props.renderTitle}/>
      </ObjectContextProvider>
    );
  }
}
